import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";
export interface ImageErrorProps {
  error?: string;
}

export const ImageError = ({ error }: ImageErrorProps) => {
  if (!error) return <>{}</>;
  return <div className={legacyClassNames("image-error")}>{error}</div>;
};
